__turbopack_context__.v({
  "defaultButton": "default-button-module__zWBKfW__defaultButton",
  "ghostButton": "default-button-module__zWBKfW__ghostButton",
  "primaryButton": "default-button-module__zWBKfW__primaryButton",
  "whiteButton": "default-button-module__zWBKfW__whiteButton",
});
